import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';

export const TooltipPerformanceNotAdmin = ({ isAdmin, children }) => {
  return (
    <Tooltip
      title={
        isAdmin ? '' : 'Please contact your account Admin to connect Anyword to this ad account.'
      }
    >
      <span>{children}</span>
    </Tooltip>
  );
};

TooltipPerformanceNotAdmin.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
